/* eslint-disable no-extend-native */
import React from 'react';
// http://erlycoder.com/49/javascript-hash-functions-to-convert-string-into-integer-hash-
String.prototype.hashMe = function(){
  var hash = 0;
  for (var i = 0; i < this.length; i++) {
    /* eslint-disable no-bitwise */
    hash = this.charCodeAt(i) + (hash << 6) + (hash << 16) - hash;
    /* eslint-enable no-bitwise */
  }
  return hash;
};

window.toHTML = function(string){
  return (<span dangerouslySetInnerHTML={{__html: string}} />);
};

String.prototype.size = function(width, font) {
  var f = font || '12px arial';
  var o;
  if (width){
    o = $('<div>')
          .html(this)
          .css({'position': 'absolute', 'float': 'left', 'max-width': width, 'visibility': 'hidden', 'font': f})
          .appendTo($('body'));
  } else {
    o = $('<div>')
          .html(this)
          .css({'position': 'absolute', 'float': 'left', 'white-space': 'nowrap', 'visibility': 'hidden', 'font': f})
          .appendTo($('body'));
  }
  var w = o.width();
  var h = o.height();

  o.remove();

  return {width: w, height: h};
};

// http://stackoverflow.com/questions/3700326/decode-amp-back-to-in-javascript
String.prototype.decodeHTML = function() {
  var elem = document.createElement('textarea');
  elem.innerHTML = this;
  return elem.value;
};

String.prototype.capitalize = function(){
  return this.toLowerCase().replace( /(\s|^)./g, function(a){ return a.toUpperCase(); } );
};

String.prototype.capitalizeFirst = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};
